import axios from "axios";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;
class Invoice {
  create = async (invoice: any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}kitchen-order-tracking`,
      data: invoice,
    }).catch((e) => {
      if(e.response.status == 403) {
        Swal.fire({
        icon: "error",
        title: "KOT Exists",
        text: "please revert or invoice the kot for this desk to continue",
        footer: `PARTIAL KOT CODES: ${e.response.data.kot.map((e:any) => `${e.code}`).join(',')}`
      });
      }
      // console.log(e.response.status);
      
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };

  edit = async (invoice: any, code: any) => {
    const res = await axios({
      method: "put",
      url: `${API_URL}kitchen-order-tracking/${code}`,
      data: invoice,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };

  completeKot = async ( code: any) => { 
    const res = await axios({
      method: "put",
      url: `${API_URL}complete-kot`,
      data: code,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };

  processKot = async ( code: any) => { 
    const res = await axios({
      method: "put",
      url: `${API_URL}process-kot`,
      data: code,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };
 
  get = async (code: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}kitchen-order-tracking/${code}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data;
  };


  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}kitchen-order-tracking`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.kot;
  };

  getkotShow = async () => {
    const response = await axios.get<any>(`${API_URL}show-kot`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.kotShow;
  };

  getkotShowByUser = async () => {
    const response = await axios.get<any>(`${API_URL}show-kot-by-user`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.kotShow;
  };

  nonInvoiceKot = async (cusCode:any) => {
    const response = await axios.get<any>(`${API_URL}non-invoice-kot?customerCode=${cusCode}`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.kot;
  };


  getLastThree = async (key: any) => {
    const response = await axios.get<any>(`${API_URL}recent-kot/${key ? key : 0}`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.kot;
  };

  getPrevKot = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}kitchen-order-tracking/${code}`)
    .catch((e) => {
      throw e.message;
    });
    return response.data.kot;
  };

  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}kot-search/${keyword}`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.kot;
  };
  
  
  reversal = async (code: any) => {
    const response = await axios({
      method: "put",
      url: `${API_URL}kot-reversal`,
      data: code
    }).catch((e) => {
      throw e.message;
    });
    return response.data;
  };

  updateKotPrintCount = async (code: number) => {
    const response = await axios({
      method: "put",
      url: `${API_URL}update-kot-print-count/${code}`,
      // data: code
    }).catch((e) => {
      throw e.message;
    });
    return response
    
  }
}
export default new Invoice();
